import { useState } from 'react';
import { Play } from '../../lib/icons';
import { executerTestsCri } from '../../lib/criCalculs';
import { Carte, btn, td, th } from './ui';

const aff = (v) => (v === null ? 'Non calculable' : typeof v === 'boolean' ? (v ? 'Oui' : 'Non') : new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(v));

export const TestsCri = () => {
  const [res, setRes] = useState(null);

  return (
    <Carte
      testid="cri-tests"
      titre="Tests métier du moteur CRI"
      sous="Scénario fictif imposé (OF Achat 10 t / OF Prestation 5 t, standard 100 TND/t) et 8 contrôles de non-régression. Aucune donnée réelle n’est modifiée."
      action={
        <button data-testid="cri-tests-run" type="button" onClick={() => setRes(executerTestsCri())} className={btn}>
          <Play size={15} /> Exécuter les tests
        </button>
      }
    >
      {!res ? (
        <p className="text-sm text-slate-500">Lancez les tests pour vérifier les formules, la base TTC, la répartition des écarts et l’étanchéité du CMP Achat.</p>
      ) : (
        <>
          <p
            data-testid="cri-tests-resultat"
            className={`mb-3 border px-3 py-2 font-data text-sm ${res.echecs === 0 ? 'border-emerald-200 bg-emerald-50 text-emerald-800' : 'border-red-200 bg-red-50 text-red-800'}`}
          >
            {res.reussis}/{res.total} contrôles réussis — {res.echecs} échec(s).
          </p>
          <div className="max-h-[520px] overflow-auto border border-slate-200">
            <table className="w-full min-w-[720px] border-collapse">
              <thead className="sticky top-0 bg-slate-50">
                <tr>
                  <th className={th}>Code</th>
                  <th className={th}>Contrôle</th>
                  <th className={th}>Attendu</th>
                  <th className={th}>Obtenu</th>
                  <th className={th}>Résultat</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {res.lignes.map((l) => (
                  <tr key={l.code} data-testid={`cri-test-${l.code}`}>
                    <td className={`${td} font-semibold`}>{l.code}</td>
                    <td className="px-3 py-2 text-sm text-slate-700">{l.libelle}</td>
                    <td className={td}>{aff(l.attendu)}</td>
                    <td className={td}>{aff(l.obtenu)}</td>
                    <td className="px-3 py-2">
                      <span className={`border px-1.5 py-0.5 font-data text-[11px] uppercase ${l.ok ? 'border-emerald-200 bg-emerald-50 text-emerald-700' : 'border-red-200 bg-red-50 text-red-700'}`}>
                        {l.ok ? 'Conforme' : 'Échec'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </Carte>
  );
};
